import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { label } from "../helpers";

var root = $.from_html(`<div class="slex-submit-bar"><button type="button" class="slex-button slex-button--ghost"> </button> <button type="button" class="slex-button slex-button--primary"> </button></div>`);

export default function Submit($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function submitTool() {
		if ($.get(p).disabled) return;

		const runtime = $$props.ctx.g.__slexkitTool;

		if (!runtime?.submit) return;

		const result = {};

		for (const key of Array.isArray($.get(p).returnKeys) ? $.get(p).returnKeys : []) {
			result[String(key)] = String(key).split(".").reduce((current, part) => current && typeof current === "object" ? current[part] : undefined, $$props.ctx.g);
		}

		runtime.submit(result);
	}

	function ignoreTool() {
		const runtime = $$props.ctx.g.__slexkitTool;

		runtime?.ignore?.();
	}

	var div = root();
	var button = $.child(div);
	var text = $.child(button, true);

	$.reset(button);

	var button_1 = $.sibling(button, 2);
	var text_1 = $.child(button_1, true);

	$.reset(button_1);
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_text(text, $0);
			button_1.disabled = !!$.get(p).disabled;
			$.set_text(text_1, $1);
		},
		[
			() => label($$props.ctx, "submit.ignore", $.get(p).ignoreLabel, "Ignore"),
			() => label($$props.ctx, "submit.submit", $.get(p).submitLabel, "Submit")
		]
	);

	$.delegated('click', button, ignoreTool);
	$.delegated('click', button_1, submitTool);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);